import Dashboard from "../MainPage/Dashboard";
import Users from "../MainPage/users";
import Appointments from "../MainPage/appointments";
import AddEditAppointment from "../MainPage/appointments/edit-add-appointment";
import Patients from "../MainPage/patients";
import Employees from "../MainPage/employees";
import Statements from "../MainPage/Statements";
import ContactEnquiries from "../MainPage/contact-enquiries";
import InventoryCRUD from "../MainPage/inventory";
import AppointmentDetails from "../MainPage/appointments/appointmentDetails";
import HistoryLogs from "../MainPage/users/HistoryLogs";
import Worklist from "../MainPage/worklist";

export default [
  {
    path: "dashboard",
    component: Dashboard,
  },
  {
    path: "users",
    component: Users,
  },
  {
    path: "employees",
    component: Employees,
  },
  {
    path: "appointments",
    component: Appointments,
  },
  {
    path: "view-appointment/:id",
    component: AppointmentDetails,
  },
  {
    path: "appointment/manage",
    component: AddEditAppointment,
  },
  {
    path: "patients",
    component: Patients,
  },
  {
    path: "reports",
    component: Statements,
  },
  {
    path: "contact-enquiries",
    component:ContactEnquiries
  },
  {
    path: 'inventory',
    component: InventoryCRUD
  },
  {
    path: 'history-logs',
    component: HistoryLogs
  },
  {
    path: 'worklist',
    component: Worklist
  }
];
